
import {Injectable} from '@angular/core';
import { Router, Route } from '@angular/router';

import { Subject, Observable } from 'rxjs';
import { MatSnackBar } from '@angular/material';
import { HttpClient } from '@angular/common/http';
import { SidenavMenu } from '../sidebar/sidebar-menu.model';
import { Product } from 'src/app/modals/product.model';
import { ApiUtils } from './ApiUtils';
import { ApiEndpoints } from './ApiEndpoints';



@Injectable({
  providedIn: 'root'
})
export class SharedMethods {

  cacheSettings: any;
  cacheLoading: any;


  // tslint:disable-next-line:max-line-length
  constructor(public apiEndpoints: ApiEndpoints, public apiUtils: ApiUtils, private httpClient: HttpClient, private router: Router, public snackBar: MatSnackBar) {

    this.getSettings().subscribe(setting => {
      this.cacheSettings = setting;
    });

  }

  public checkIdProdBuy(idprod: number) {

    if(!this.cacheLoading || !this.cacheLoading.idprodbuy)
      return false;

    const index = this.cacheLoading.idprodbuy.findIndex(item => item === idprod)
    if(index > -1)
    return true;
    else
    return false;

  }

  public dataloading(): Observable<any> {
    // return this.httpClient.get<Product[]>('assets/data/products2.json');
    if(this.apiUtils.CURRENT_ACCESS_TOKEN)
        return this.httpClient.get<Product[]>(this.apiEndpoints.URL_GET_LOADING, {headers: this.apiUtils.SECURE_API_REQUEST_HEADER()});
      else
        return this.httpClient.get<Product[]>(this.apiEndpoints.URL_GET_LOADING, {headers: this.apiUtils.BASIC_API_REQUEST_HEADER()});
    // return [];
  }

  successApiShow(message) {

    const status = 'success';
    this.snackBar.open(message, '×', { panelClass: [status], verticalPosition: 'top', duration: 3000 });

  }

  errorApiShow(code: number, message: string) {

    if ( code === undefined) {

           const allmessage = 'Aucune réponse du serveur. Vérifier votre connexion et réessayez';
           // const status = 'error';
           const status = 'success';
           this.snackBar.open(allmessage, '×', { panelClass: [status], verticalPosition: 'bottom', duration: 3000 });

    } else {

        if ( code === 401 ) {
          // erreur du à l'invalidité du token
          /* this.settingService.search = false;
          this.router.navigate(['/auth/pages/login']); */
          const allmessage = 'Utilisateur non authentifié. Veillez vous déconnecter et connectez-vous à nouveau pour resoudre ce problème.';
          // const status = 'error';
          const status = 'success';
          this.snackBar.open(allmessage, '×', { panelClass: [status], verticalPosition: 'bottom', duration: 5000 });
          // this.router.navigate(['/pages/login']);

        } else {

            /*
            // tslint:disable-next-line:no-console
            console.log(code);
            // tslint:disable-next-line:no-console
            console.log(message);
            */

            /* swal({
                type: 'error',
                title: 'Erreur interne au serveur',
                text: 'Contactez votre administrateur!',
                allowOutsideClick: false,
            }); */

            // const status = 'error';
            const status = 'success';
            this.snackBar.open(message, '×', { panelClass: [status], verticalPosition: 'bottom', duration: 3000 });

            // this.sweetalert('error', 'Echec de l\'opération', message);

        }


    }

  }

  public settings(): Observable<any>{
    return this.httpClient.get<any>('assets/data/settings.json');
  }


  // Get Banners
  public getSettings() {
    return this.settings();
  }

  /* generateSlug(str: string): string {

    if(str === undefined)
    return '';

    const a = 'àáâäæãåāăąçćčđďèéêëēėęěğǵḧîïíīįìłḿñńǹňôöòóœøōõőṕŕřßśšşșťțûüùúūǘůűųẃẍÿýžźż·/_,:;'
    const b = 'aaaaaaaaaacccddeeeeeeeegghiiiiiilmnnnnoooooooooprrsssssttuuuuuuuuuwxyyzzz------'
    const p = new RegExp(a.split('').join('|'), 'g')

    return  str.toString()
                    .toLowerCase()
                    .replace(/\s+/g, '-') // Replace spaces with -
                    .replace(p, c => b.charAt(a.indexOf(c))) // Replace special characters
                    .replace(/&/g, '-and-') // Replace & with 'and'
                    .replace(/[^\w\-]+/g, '') // Remove all non-word characters
                    .replace(/\-\-+/g, '-') // Replace multiple - with single -
                    .replace(/^-+/, '') // Trim - from start of text
                    .replace(/-+$/, '') // Trim - from end of text

  }*/

  createProduct(element) {
    // tslint:disable-next-line:max-line-length
    return new Product(element.id, element.designation, element.prix_detail, null, null, null, null, element.description, null, false, null, false, null, null, null, null, element.sell_in_ligne, element.images, element.image_principale, element.categories, element.fichier_telechargeable, null, element.type, element.is_publish, element.souscribe_mode, element.nbr_oders, element.other_file, element.is_external_link, element.external_link);
  }


}